import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=69205759"
import script from "./Approvers.vue?vue&type=script&lang=js"
export * from "./Approvers.vue?vue&type=script&lang=js"
import style0 from "./Approvers.vue?vue&type=style&index=0&id=69205759&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports